type StatusPillProps = {
  status: "ok" | "attention" | "idle";
};

export default function StatusPill({ status }: StatusPillProps) {
  const color =
    status === "ok"
      ? "bg-green-500/20 text-green-400 ring-green-500/30"
      : status === "attention"
      ? "bg-yellow-500/20 text-yellow-400 ring-yellow-500/30"
      : "bg-gray-500/20 text-gray-300 ring-gray-500/30";

  const label = status === "ok" ? "OK" : status === "attention" ? "Attention" : "Idle";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${color}`}
    >
      <span className="block h-1.5 w-1.5 rounded-full bg-current"></span>
      {label}
    </span>
  );
}


